function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0 79 125.428 79 125.428 0.605 0 0.605"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.986,6.729 C0.986,10.272 3.666,12.918 7.247,12.918 L7.247,12.918 C10.732,12.918 13.486,10.237 13.486,6.797 L13.486,6.797 C13.486,3.38 10.75,0.698 7.247,0.698 L7.247,0.698 C3.789,0.698 0.986,3.397 0.986,6.729",
  id: "path-3"
}), /*#__PURE__*/React.createElement("radialGradient", {
  cx: "50%",
  cy: "50%",
  fx: "50%",
  fy: "50%",
  r: "50%",
  gradientTransform: "translate(0.500000,0.500000),scale(0.977600,1.000000),rotate(90.000000),translate(-0.500000,-0.500000)",
  id: "radialGradient-5"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFFFFF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F58220",
  offset: "100%"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "discover_icon",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-22",
  transform: "translate(0.000000, -1.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(0.000000, 0.394600)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M127.9998,76.3376809 C127.9998,78.6939536 126.088393,80.6053 123.732045,80.6053 L4.26551419,80.6053 C1.90916633,80.6053 -0.0002,78.6939536 -0.0002,76.3376809 L-0.0002,4.87291911 C-0.0002,2.51460544 1.90916633,0.6053 4.26551419,0.6053 L123.732045,0.6053 C126.088393,0.6053 127.9998,2.51460544 127.9998,4.87291911 L127.9998,76.3376809 Z",
  id: "Fill-1",
  fill: "#F1F2F2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.9998,80.6053 L123.724608,80.6053 C126.084604,80.6053 127.9998,78.7063288 127.9998,76.3653119 L127.9998,46.6053 C119.484182,51.9574992 87.3788283,70.4108763 34.9998,80.6053",
  id: "Fill-4",
  fill: "#F58220"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-21",
  transform: "translate(1.000000, 1.394600)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M31.3867,42.7324 C30.6617,43.3844 29.7327,43.6664 28.2497,43.6664 L27.6347,43.6664 L27.6347,35.9044 L28.2497,35.9044 C29.7327,35.9044 30.6267,36.1684 31.3867,36.8534 C32.1777,37.5584 32.6487,38.6484 32.6487,39.7734 C32.6487,40.9024 32.1777,42.0314 31.3867,42.7324 M28.7087,33.9164 L25.3457,33.9164 L25.3457,45.6544 L28.6937,45.6544 C30.4687,45.6544 31.7537,45.2324 32.8807,44.3004 C34.2167,43.1894 35.0097,41.5174 35.0097,39.7914 C35.0097,36.3264 32.4217,33.9164 28.7087,33.9164",
  id: "Fill-10",
  fill: "#001722"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-13"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-12",
  fill: "#001722",
  mask: "url(#mask-2)",
  points: "36.066 45.654 38.351 45.654 38.351 33.916 36.066 33.916"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.9512,38.4179 C42.5762,37.9099 42.1742,37.5739 42.1742,36.9409 C42.1742,36.2029 42.8942,35.6409 43.8812,35.6409 C44.5662,35.6409 45.1292,35.9219 45.7302,36.5879 L46.9262,35.0249 C45.9392,34.1599 44.7602,33.7209 43.4742,33.7209 C41.4002,33.7209 39.8142,35.1639 39.8142,37.0819 C39.8142,38.7029 40.5532,39.5289 42.7012,40.3029 C43.5992,40.6189 44.0562,40.8299 44.2852,40.9729 C44.7422,41.2729 44.9722,41.6929 44.9722,42.1859 C44.9722,43.1389 44.2172,43.8399 43.1932,43.8399 C42.1012,43.8399 41.2222,43.2969 40.6952,42.2749 L39.2192,43.7029 C40.2712,45.2499 41.5392,45.9379 43.2832,45.9379 C45.6582,45.9379 47.3302,44.3519 47.3302,42.0819 C47.3302,40.2169 46.5582,39.3709 43.9512,38.4179",
  id: "Fill-14",
  fill: "#001722",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.0508,39.791 C48.0508,43.244 50.7618,45.918 54.2478,45.918 C55.2348,45.918 56.0778,45.725 57.1168,45.232 L57.1168,42.539 C56.2008,43.455 55.3908,43.822 54.3538,43.822 C52.0488,43.822 50.4098,42.15 50.4098,39.773 C50.4098,37.523 52.0978,35.744 54.2478,35.744 C55.3378,35.744 56.1658,36.133 57.1168,37.064 L57.1168,34.371 C56.1148,33.861 55.2848,33.652 54.3008,33.652 C50.8318,33.652 48.0508,36.381 48.0508,39.791",
  id: "Fill-15",
  fill: "#001722",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-16",
  fill: "#001722",
  mask: "url(#mask-2)",
  points: "75.6661 41.8007 72.5351 33.9157 70.0331 33.9157 75.0181 45.9547 76.2481 45.9547 81.3181 33.9157 78.8381 33.9157"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-17",
  fill: "#001722",
  mask: "url(#mask-2)",
  points: "82.3594 45.6543 88.8514 45.6543 88.8514 43.6663 84.6444 43.6663 84.6444 40.4963 88.6914 40.4963 88.6914 38.5093 84.6444 38.5093 84.6444 35.9043 88.8514 35.9043 88.8514 33.9163 82.3594 33.9163"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.3204,39.3183 L92.6544,39.3183 L92.6544,35.7613 L93.3574,35.7613 C94.7854,35.7613 95.5584,36.3633 95.5584,37.5043 C95.5584,38.6833 94.7854,39.3183 93.3204,39.3183 M97.9144,37.3813 C97.9144,35.1813 96.4024,33.9163 93.7614,33.9163 L90.3634,33.9163 L90.3634,45.6543 L92.6544,45.6543 L92.6544,40.9373 L92.9534,40.9373 L96.1214,45.6543 L98.9354,45.6543 L95.2384,40.7093 C96.9654,40.3573 97.9144,39.1773 97.9144,37.3813",
  id: "Fill-18",
  fill: "#001722",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M99.0957,34.9316 L99.0527,34.9316 L99.0527,34.6636 L99.0977,34.6636 C99.2227,34.6636 99.2827,34.7066 99.2827,34.7946 C99.2827,34.8846 99.2207,34.9316 99.0957,34.9316 M99.5297,34.7906 C99.5297,34.5856 99.3907,34.4726 99.1387,34.4726 L98.8067,34.4726 L98.8067,35.5076 L99.0527,35.5076 L99.0527,35.1056 L99.3397,35.5076 L99.6487,35.5076 L99.3047,35.0796 C99.4497,35.0406 99.5297,34.9356 99.5297,34.7906",
  id: "Fill-19",
  fill: "#231F20",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M99.1875,35.7285 C98.7875,35.7285 98.4645,35.4005 98.4645,34.9905 C98.4645,34.5765 98.7835,34.2485 99.1875,34.2485 C99.5785,34.2485 99.8985,34.5825 99.8985,34.9905 C99.8985,35.3965 99.5785,35.7285 99.1875,35.7285 M99.1895,34.0835 C98.6875,34.0835 98.2875,34.4865 98.2875,34.9885 C98.2875,35.4885 98.6895,35.8905 99.1895,35.8905 C99.6795,35.8905 100.0825,35.4845 100.0825,34.9885 C100.0825,34.4925 99.6795,34.0835 99.1895,34.0835",
  id: "Fill-20",
  fill: "#231F20",
  mask: "url(#mask-2)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-9",
  transform: "translate(58.000000, 34.394600)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.247,12.918 C10.732,12.918 13.486,10.237 13.486,6.797 C13.486,3.38 10.75,0.698 7.247,0.698 C3.789,0.698 0.986,3.397 0.986,6.729 C0.986,10.272 3.666,12.918 7.247,12.918 Z",
  id: "Fill-7",
  fill: "url(#radialGradient-5)",
  mask: "url(#mask-4)"
}))));

function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "80px",
    viewBox: "0 0 128 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "discover_icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.10b16850.svg";
export { ForwardRef as ReactComponent };